module.exports = __webpack_public_path__ + "trademark11.png?9bc26e5fb66022abd4fc0dd4c4396374";


//////////////////
// WEBPACK FOOTER
// ./static/assets/trademark11.png
// module id = 496
// module chunks = 0